// extracted by mini-css-extract-plugin
export default {"modalTitleContainer":"style_modalTitleContainer__4bFO0"};